import React from 'react'
import PropTypes from 'prop-types'
import { useField } from 'formik'

import useStyles from './styles'
import { useTranslation } from 'react-i18next'


const parseError = (msg, t) => {
  if (typeof msg === 'object') return Object.values(msg).map(m => parseError(m, t)).join('; ')
  return t(msg)
}

const ErrorMessage = ({ id }) => {
  const [, meta, ] = useField(id)
  const { t } = useTranslation(['translation'])
  const classes = useStyles()
  
  return meta.error ? (
    <div className={classes.errorMessage}>{parseError(meta.error, t)}</div>
  ) : null

}

ErrorMessage.propTypes = {
  id: PropTypes.string.isRequired,
}

export default ErrorMessage
